import { render, staticRenderFns } from "./submitPrompt.vue?vue&type=template&id=7636edd0&scoped=true&"
import script from "./submitPrompt.vue?vue&type=script&lang=js&"
export * from "./submitPrompt.vue?vue&type=script&lang=js&"
import style0 from "./submitPrompt.vue?vue&type=style&index=0&id=7636edd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636edd0",
  null
  
)

export default component.exports